// MainMapMarkerManager.js
// Zentrale Marker-Verwaltung für alle Marker-Typen (document, cluster, gallery, etc.)

export class MainMapMarkerManager {
    mapAdapter;
    markerMap = new Map(); // Key: Marker-ID, Value: MarkerEntry[]

    constructor(mapAdapter) {
        this.mapAdapter = mapAdapter;
    }

    /**
     * Registriert einen Marker in der zentralen Map (Mehrfach-Marker pro ID erlaubt)
     * @param {object} marker - z.B. AdvancedMarkerView
     * @param {string} id - Eindeutige Marker-ID
     * @param {"document"|"cluster"|"gallery"|"archive"} type
     * @param {string[]} [docIds] - Zugehörige Dokument-IDs (optional)
     * @param {LatLng} [position] - Geoposition des Markers (optional)
     */
    addMarker(marker, id, type, docIds = [], position = null) {
        const entry = {
            id,
            marker,
            type,
            docIds,
            position
        };
        if (!this.markerMap.has(id)) {
            this.markerMap.set(id, []);
        }
        this.markerMap.get(id).push(entry);
    }

    clearAllMarkers() {
        for (const entries of this.markerMap.values()) {
            for (const entry of entries) {
                if (typeof entry.marker?.setMap === 'function') {
                    entry.marker.setMap(null);
                }
            }
        }
        this.markerMap.clear();
    }

    clearMarkersByType(type) {
        for (const [id, entries] of this.markerMap.entries()) {
            const remaining = entries.filter(entry => {
                if (entry.type === type) {
                    if (typeof entry.marker?.setMap === 'function') {
                        entry.marker.setMap(null);
                    }
                    return false;
                }
                return true;
            });
            if (remaining.length === 0) {
                this.markerMap.delete(id);
            } else {
                this.markerMap.set(id, remaining);
            }
        }
    }

    getMarkersByType(type) {
        const result = [];
        for (const entries of this.markerMap.values()) {
            result.push(...entries.filter(entry => entry.type === type));
        }
        return result;
    }

    getMarkersByDocId(docId) {
        const result = [];
        for (const entries of this.markerMap.values()) {
            result.push(...entries.filter(entry => entry.docIds.includes(docId)));
        }
        return result;
    }

    getClusterByDocId(docId) {
        for (const entries of this.markerMap.values()) {
            const match = entries.find(entry => entry.type === 'cluster' && entry.docIds.includes(docId));
            if (match) return match;
        }
        return null;
    }

    getMarkerById(id) {
        return this.markerMap.get(id) || [];
    }

    removeMarker(id) {
        const entries = this.markerMap.get(id);
        if (Array.isArray(entries)) {
            for (const entry of entries) {
                if (typeof entry.marker?.setMap === 'function') {
                    entry.marker.setMap(null);
                }
            }
        }
        this.markerMap.delete(id);
    }
}

// Subklassen wie DocumentMarkerManager oder GalleryMarkerManager verwenden addMarker(...)
// Beispiel:
// this.addMarker(marker, "doc_123", "document", ["123"], marker.position);
